export const MY_PRICE = "MY_PRICE";
export const CMP = "CMP";
